//
//
//
//
//
//
//
//
//

import qs from 'qs'

export default {
  name: 'm-evaluation',
  mounted () {
    this.$store.commit('updateProductId', this.$route.params.productId)
    this.$store.commit('updateUserId', this.$route.params.userId)
    // this.$store.commit('updateOrderOpenId', this.$route.params.openId)
    this.$store.commit('updateOrderUnionOrderCode', this.$route.params.unionCode)
    document.title = '评论详情'
  },
  computed: {
    message: {
      get () {
        return this.$store.state.holder.message
      },
      set (value) {
        this.$store.commit('updateHolderMessage', value.trim())
      }
    }
  },
  methods: {
    submitMessage () {
      if (this.$store.state.holder.message.trim() === '') {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，给个好评呗~',
          position: 'top',
          width: '20em'
        })
        return
      }
      this.$vux.loading.show({
        text: '正在提交'
      })
      this.$http.get('/api/hqdqx/orderQueren/' + this.$store.state.order.userId + '/' + this.$store.state.order.productId + '/' + this.$store.state.order.unionOrderCode).then(response => {
        if (response.data === 'error') {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'warn',
            text: '提交失败'
          })
          return
        }
        const phone = response.data.underwritingInfoList[0].policyHolder.holderPhone
        this.$http.get('/api/hqdqx/getAgentUserInfoByPhone/' + phone).then(response => {
          const data = {
            nickName: '',
            pingjiaValue: this.$store.state.holder.message
          }
          if (response.data === 'error' || response.data.name === undefined) {
            data.nickName = phone
          } else {
            data.nickName = response.data.name
          }
          this.$http.get('/api/hqdqx/evaluate/' + this.$store.state.order.unionOrderCode + '/' + this.$store.state.order.productId + '?' + qs.stringify(data)).then(response => {
            this.$vux.loading.hide()
            if (response.data === true) {
              this.$vux.toast.show({
                type: 'success',
                text: '提交成功'
              })
              this.$router.push({name: 'Result', params: {productId: this.$store.state.order.productId, userId: this.$store.state.order.userId, unionCode: this.$store.state.order.unionOrderCode}, query: this.$route.query})
            } else if (response.data === false) {
              this.$vux.toast.show({
                type: 'text',
                text: '客官，提交失败',
                position: 'top',
                width: '20em'
              })
            } else {
              this.$vux.toast.show({
                type: 'text',
                text: '客官，' + response.data.substring(6),
                position: 'top',
                width: '20em'
              })
            }
          })
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Evaluation.vue